import { AbstractAttributeList } from "./AbstractAttributeList";
import { EmployeeAttribute } from "./EmployeeAttribute";
import { GapAttribute } from "./GapAttribute";

export class GapAttributeList extends AbstractAttributeList {

  [key: string]: any;

  constructor(options: any) {
    super(options);
    options.data.forEach((attr: any, index: any) =>
      this.attributes.push(new GapAttribute(index, attr))
    );
  }

  initAttributesLists(jobAttributes?: any, employeeAttributes?: any) {
    jobAttributes.attributes.forEach((jobAttr: any) => {
      const gap = this.attributes.find(
        (g) => g.attributeDefinitionId == jobAttr.attributeDefinitionId
      );
      if (gap) {
        gap.isParent = jobAttr.isParent;
        gap.hasExpiryDate = jobAttr.hasExpiryDate;
        gap.hasProficiency = jobAttr.hasProficiency;
        gap.required = jobAttr.required;
        gap.mandatory = jobAttr.mandatory;
        if (jobAttr.isParent) {
          gap.childAttributes = [...jobAttr.childAttributes];
          gap.childAttributes.forEach((childAttr: any, index: any) => {
            childAttr.rowId = gap.attributeDefinitionId + childAttr.attributeDefinitionId;
            childAttr.isChild = true;
            childAttr.childIndex = index;
            childAttr.isLastChild = index === gap.childAttributes.length - 1;
            childAttr.attributeHierarchy = [
              gap.attributeDefinitionId,
              childAttr.attributeDefinitionId
            ];
            childAttr.parentAttributeId = gap.attributeId;
          });
        }
      }
    });

    employeeAttributes.attributes.forEach((emplAttr: any) => {
      const gap = this.attributes.find(
        (g) => g.attributeDefinitionId == emplAttr.attributeDefinitionId
      );

      if (gap) {
        gap.proficiency = emplAttr.proficiency;
        gap.expiryDate = emplAttr.expiryDate;
        gap.currentExpiryDate = emplAttr.currentExpiryDate;
        gap.requestedExpiryDate = emplAttr.requestedExpiryDate;
        gap.currentProficiency = emplAttr.currentProficiency;
        gap.requestedProficiency = emplAttr.requestedProficiency;
      }
    });

    super.initAttributesLists();
  }

  static getFilterItems(includeProficiency: any) {
    const filters: any = {
      all: {
        ...AbstractAttributeList.allFilter
      }
    };
    if (includeProficiency) filters["lowProficiency"] = GapAttribute.reason.lowProficiency;
    filters["missing"] = GapAttribute.reason.missing;
    filters["needsFeedback"] = EmployeeAttribute.status.feedback;
    filters["underReview"] = EmployeeAttribute.status.review;
    return filters;
  }
}
